import React from 'react';
import { useState } from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { useOnClickOutside } from 'lib/utils';
import { Modal, RadioInput } from 'lib/components';
import { updateUser } from 'lib/api';
import { theme } from 'lib/style';
import { successToast } from 'lib/components/toasts/success';
import { errorToast } from 'lib/components/toasts/error';
import { Button } from 'react-covideo-common';
import { IoMdClose } from 'react-icons/io';
import { useTranslation } from 'react-i18next';

const Header = styled.div`
  display: flex;
`;
const HeaderTitle = styled.div`
  ${theme.fontBold700}
  font-size: ${theme.fontSizes.lg};
  color: ${theme.palette.coal};
  font-size: 18px;
  line-height: 24px;
`;
const CloseButtonWrap = styled.div`
  margin-left: auto;
  color: ${theme.palette.white};
  height: 24px;
  width: 24px;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`;
const Content = styled.div`
  width: 600px;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const RadioWrapper = styled.div`
  margin-bottom: 6px;
`;
const SubmitButtonWrapper = styled.div`
  text-align: right;
  margin: 32px 0 0 auto;
`;
const Label = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.palette.gray80};
  margin-bottom: 8px;
`;

type Props = {
  handleModalClose: (shouldRefresh?: boolean | number) => void;
  selectedUser: number[];
};

export const ModalVideoApproval = ({
  handleModalClose,
  selectedUser,
}: Props) => {
  const { t } = useTranslation();
  const [vdpEnabled, setVdpEnabled] = useState(2);
  const [loadingModal, setLoadingModal] = React.useState(false);
  const { ref } = useOnClickOutside(handleModalClose);
  const themes = useTheme();

  const handleUpdateVdpEnabled = async () => {
    setLoadingModal(true);
    let count = 0;
    let errorCount = 0;
    for (const userId of selectedUser) {
      try {
        await updateUser(userId, { vdpEnabled }, true);
        count++;
      } catch (error) {
        errorCount++;
        console.log('Error', error);
      }
    }
    handleModalClose(1);
    setLoadingModal(false);
    if (errorCount) {
      errorToast({
        title: t('Something went wrong while updating video approval.'),
      });
    } else {
      count &&
        successToast({
          title: t('videoApprovalUpdatedSuccessfully', { count }),
        });
    }
    setLoadingModal(false);
  };

  return (
    <Modal style={{ position: 'fixed' }}>
      <div ref={ref} style={{ padding: '32px' }}>
        <Header>
          <HeaderTitle>
            {t(
              selectedUser.length === 1
                ? 'Select access level for {{count}} user'
                : 'Select access level for {{count}} users',
              { count: selectedUser.length }
            )}
          </HeaderTitle>
          <CloseButtonWrap title={t('Close')}>
            <IoMdClose
              size={24}
              onClick={() => handleModalClose()}
              color={theme.palette.label}
            />
          </CloseButtonWrap>
        </Header>
        <Content>
          <Label>{t('Can user push videos to a Vehicle details page?')}</Label>
          <RadioWrapper>
            <RadioInput
              name={'Status'}
              value={1}
              text={t('Can push to a VDP')}
              checkedColor={themes.colors.primary[100]}
              checked={vdpEnabled === 1}
              onChange={() => {}}
              onClick={() => setVdpEnabled(1)}
            />
          </RadioWrapper>
          <RadioWrapper>
            <RadioInput
              name={'Status'}
              value={0}
              text={t('Can’t push to a VDP')}
              checkedColor={themes.colors.primary[100]}
              checked={vdpEnabled === 0}
              onChange={() => {}}
              onClick={() => setVdpEnabled(0)}
            />
          </RadioWrapper>
          <SubmitButtonWrapper>
            <Button
              text={t('Update')}
              onClick={() => handleUpdateVdpEnabled()}
              disabled={!(vdpEnabled === 0 || vdpEnabled === 1) || loadingModal}
            />
          </SubmitButtonWrapper>
        </Content>
      </div>
    </Modal>
  );
};
